import { BackgroundCheck } from "@wingspanhq/wingspan-api-sdk";
import { WSQueryCache } from "@ws-react-query";

import { queriesBackgroundChecks } from "../../../../../../v3/query/queriesBackgroundChecks";
import { ContextItem, RequirementTableItemData } from "../../../../types";

export const getBackgroundCheckFromCache = (
  requirement: RequirementTableItemData,
  contextItem: ContextItem
): BackgroundCheck | undefined => {
  if (!requirement.dataSourceId) {
    return undefined;
  }

  return WSQueryCache.getQueryData<BackgroundCheck>(
    queriesBackgroundChecks.getBackgroundCheck.getQueryKey({
      backgroundCheckId: requirement.dataSourceId
    })
  );
};
